module.exports = __webpack_public_path__ + "img/rukuguanli.4b229928.png";